import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { DirectComponent } from "./page/direct/direct.component";
import { EmailTemplateDesignerComponent } from "./page/email-template-designer/email-template-designer.component";
import { TaskDetailPageComponent } from "./page/task-detail/task-detail.component";

const routes: Routes = [
  {
    path: "",
    component: DirectComponent,
  },
  {
    path: ":module/task-detail/:taskId",
    component: TaskDetailPageComponent,
  },
  {
    path: ":module",
    component: DirectComponent,
  },
  {
    path: ":module/email-designer",
    component: EmailTemplateDesignerComponent,
  },
  {
    // Legacy Designer deep-link → same shell (list/canvas owned internally)
    path: ":module/direct/Designer",
    component: DirectComponent,
  },
  {
    path: ":module/page",
    pathMatch: "full",
    component: DirectComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DirectRoutingModule {}
